import React from 'react'
import { Table } from "react-bootstrap";
import {
  TopRatedListSection,
  TableSection,
  Thead,
  TableRowData,
  TableHead,
  Tbody,
  TableDiv,
} from './tableStyle'
import { TableColumnsProps, TableProps } from '../../../utils/types';

const TableRow = ({ data, onClickRow }: any) => {
  return (
    <TableRowData onClick={onClickRow}>
      {data?.map((item: any, index: number) => (
        <TableDiv key={index + 1}>
          {item.render ? item.render(item.val, {}) : item.val}
        </TableDiv>
      ))}
    </TableRowData>
  )
};

const CommonTable = ({ columns, data, handleRowClick, tableRef = null }: TableProps) => {

  return (

    <TopRatedListSection className='table-section'>
      <TableSection style={{ maxHeight: "690px", overflowY: "auto" }}>
        <Table size="sm" ref={tableRef ?? null} responsive hover>
          <Thead className='table-heading'>
            <TableRowData>
              {columns?.map((column: TableColumnsProps, i: number) => (
                <TableHead key={i + 1}>{column.header}</TableHead>
              ))}
            </TableRowData>
          </Thead>
          <Tbody className='table_body'>
            {data?.map((row: any, index: number) => (
              <TableRow
                key={index + 1}
                data={columns.map((key: TableColumnsProps) => ({
                  key: key.id,
                  val: row[key.id],
                  render: key.render
                }))}
                onClickRow={() => {
                  handleRowClick(row)
                }}
              />
            ))}
          </Tbody>

        </Table>
      </TableSection>
    </TopRatedListSection>

  )
}

export default CommonTable
